import { useAuth } from "modules/auth/Auth"
import { useAuthorizedRoutes } from "pages/router"
import { ReactNode } from "react"
import { generatePath, Navigate, useParams } from "react-router"

export function ProtectedRoute({ children }: { children: ReactNode }) {
	const { isSignedIn } = useAuth()
	const params = useParams()
	const { allowedRoutes, activeRouteIsAuthorized, isFetched } =
		useAuthorizedRoutes()

	if (!isSignedIn) {
		window.location.href = `/login?next=${location.pathname}`
		return null
	}

	if (!isFetched) {
		return null
	}

	if (!activeRouteIsAuthorized) {
		const firstScopedRoute = allowedRoutes.find((route) =>
			route.includes(":scopeId"),
		)
		const fallbackRoute =
			firstScopedRoute && params.scopeId
				? generatePath(firstScopedRoute, params)
				: allowedRoutes[0]

		return <Navigate to={fallbackRoute} replace />
	}

	return children
}
